var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9141 16.4999C11.3047 16.8904 11.3047 17.5235 10.9141 17.914C10.5236 18.3045 9.8906 18.3045 9.50007 17.914L0.793044 9.20696L9.50008 0.499924C9.8906 0.1094 10.5236 0.1094 10.9141 0.499924C11.3047 0.890449 11.3047 1.52346 10.9141 1.91399L3.62117 9.20696L10.9141 16.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-left.d376a141512d724e0cef4f7c70dc03af.svg";
export { ForwardRef as ReactComponent };